import React from "react";

const CardDetails = ({
  list,
  handleonClick,
  className = "col-xs-1  card-body border border-secondary border-bottom-0 border-right-0",
}) => {
  return (
    <>
      {
        <div
          style={{ width: 100, maxHeight: 30, fontSize: "12px" }}
          className={"m-1 shadow"}
        >
          {list && list.color == 2 ? (
            <div
              className="justify-content-center 
          "
            >
              <span
                className="badge  bg-warning text-dark"
                style={{ fontSize: "12px", cursor: "pointer" }}
                onClick={() => handleonClick(list.id)}
              >
                {" "}
                {list.pro} {list.driven}{" "}
              </span>
            </div>
          ) : list && list.color == 3 ? (
            <div
              className="justify-content-center
          "
            >
              <span
                className="badge bg-danger"
                style={{ fontSize: "12px", cursor: "pointer" }}
                onClick={() => handleonClick(list.id)}
              >
                {" "}
                {list.pro} {list.driven}{" "}
              </span>
            </div>
          ) : list && list.color == 4 ? (
            <div
              className="justify-content-center
          "
            >
              <span
                className="badge bg-success"
                style={{ fontSize: "12px", cursor: "pointer" }}
                onClick={() => handleonClick(list.id)}
              >
                {" "}
                {list.pro} {list.driven}{" "}
              </span>
            </div>
          ) : null}
        </div>
      }
    </>
  );
};

export default CardDetails;
